import getConfig from 'next/config';

export const articleAudioFeatureFlag = 'enable-article-audio';

/**
 * @typedef {object} ArticleAudioMetadata
 * @property {string} [html]
 * @property {string} [stylesheetUrl]
 * @property {string} [scriptUrl]
 */

/**
 * @param {string} articleId
 * @param {object} [flags]
 * @param {object} logger
 * @returns {Promise<ArticleAudioMetadata|null>}
 */
export function getArticleTextToSpeechAudio(articleId, flags, logger) {
  const {
    serverRuntimeConfig: { TEXT_TO_SPEECH_API_URL },
  } = getConfig();

  const isArticleAudioEnabled = flags?.[articleAudioFeatureFlag];

  if (!isArticleAudioEnabled) {
    return Promise.resolve(null);
  }

  return fetch(`${TEXT_TO_SPEECH_API_URL}/api/embed/article/${articleId}`)
    .then((res) => res.json())
    .catch((err) => {
      logger.error({
        message: 'AIX TTS',
        articleId,
        err,
      });
      return null;
    });
}
